import(/* webpackMode: "eager", webpackExports: ["AdsPanel"] */ "/app/apps/web/src/Components/Plp/Filters/Components/AdsPanel/AdsPanel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FilterPanel"] */ "/app/apps/web/src/Components/Plp/Filters/FilterPanel.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/Components/Plp/PlpWrapper.module.css");
